import type { Channel } from '@swchat/protocol';
import { Icon } from '../design';

/** Kênh có thông báo QUAN TRỌNG chưa đọc (và còn theo dõi) → chuông/biểu tượng lắc để nhắc. */
export const needsAttention = (c: Pick<Channel, 'muted' | 'archived' | 'unread_important'>) => !c.muted && !c.archived && c.unread_important > 0;

/**
 * Thanh kênh đã ghim ở cuối trang chat: mỗi kênh là một ô ngang (biểu tượng + tên + số chưa đọc). Kênh có thông báo
 * quan trọng chưa đọc thì biểu tượng lắc chuông; bấm để mở thẳng kênh đó ở màn Thông báo.
 */
export function PinnedChannelsBar({ channels, onOpen }: { channels: Channel[]; onOpen: (id: string) => void }) {
  // Kênh quản trị ghim cho tất cả đứng trước, rồi tới kênh tự ghim.
  const pinned = channels.filter((c) => (c.pinned || c.pinned_all) && !c.archived).sort((a, b) => Number(b.pinned_all) - Number(a.pinned_all));
  if (!pinned.length) return null;
  return (
    <nav className="ws-pinbar" aria-label="Kênh thông báo đã ghim" data-testid="pinned-channels">
      {pinned.map((c) => {
        const ring = needsAttention(c);
        return (
          <button key={c.id} type="button" className={`ws-pinbar-item${ring ? ' is-ringing' : ''}`} data-testid="pinned-channel" data-ringing={ring ? 'true' : undefined} data-channel-id={c.id} data-pinned-all={c.pinned_all ? 'true' : undefined} title={c.description || c.name} onClick={() => onOpen(c.id)}>
            <span className={`ws-announce-icon ${c.color}${ring ? ' ws-bell-ring' : ''}`}>
              <Icon name={ring ? 'bell' : c.icon} size={14} />
            </span>
            <span className="ws-pinbar-name">{c.name}</span>
            {!c.muted && c.unread > 0 && <em aria-label={`${c.unread} chưa đọc`}>{c.unread > 99 ? '99+' : c.unread}</em>}
          </button>
        );
      })}
    </nav>
  );
}
